import type { Ability } from "@foodlista/access-control/types"
import type { z } from "zod"

export interface OperationManifest {
	type: string
	ability: Ability
	usageAbility?: Ability
	bocLabelKey: string
}

export function defineOperationManifest<const T extends OperationManifest>(
	manifest: T,
): T {
	return manifest
}

/**
 * Descriptive projection of an operation's input, persisted once on the
 * envelope so consumers can label, scope and deep-link an operation without
 * reading the Trigger.dev run payload. `version` is stored next to the value
 * so a future projection change is migrated rather than guessed.
 */
export interface OperationContextSpec<TInput, TContext> {
	version: number
	schema: z.ZodType<TContext>
	fromInput: (input: TInput) => TContext
}

export function defineOperationContext<TInput, TContext>(
	spec: OperationContextSpec<TInput, TContext>,
): OperationContextSpec<TInput, TContext> {
	return spec
}
